import { FC, useMemo } from 'react'
import SeverityIndicator from '@/ui/components/severityIndicator'
import { DisplayCard } from '@/ui/components/displayCard'
import { TTheme, useCustomTheme } from '@/core/theme'
import { RiskLevelWrapper, CategoryBarContainer } from './RiskLevelCard.styles'
import { SEVERITY_CONFIG } from '@/ui/utils/utils'
import Typography from '@/ui/components/typography'
import { CategoryBar } from '@/ui/components/categoryBar'
import { useRiskLevelSeverity } from '../../hooks/useRiskLevelSeverity'

const RiskLevelCard: FC = () => {
    const theme = useCustomTheme()
    const severity = useRiskLevelSeverity()

    const categories = useMemo(
        () =>
            Object.entries(SEVERITY_CONFIG)
                .reverse()
                .map(([key, value]) => ({
                    color: value.color(theme as TTheme),
                    text: value.text,
                    isSelected: severity === key,
                })),
        [severity, theme]
    )

    return (
        <RiskLevelWrapper>
            <DisplayCard name="Risk Level" data-testid="risk-level-card">
                <SeverityIndicator severity={severity} />
                <CategoryBarContainer
                    data-testid="risk-level-category-bar"
                    data-severity={severity}
                >
                    <CategoryBar categories={categories} />
                </CategoryBarContainer>
                <Typography
                    variant="xs-regular"
                    color={theme.colors.greys[700]}
                    data-testid="risk-level-description"
                    whiteSpaceRule="break-spaces"
                >
                    This score represents the overall cybersecurity risk of your
                    organization.
                </Typography>
            </DisplayCard>
        </RiskLevelWrapper>
    )
}

export default RiskLevelCard
